import React from 'react'
import cn from 'classnames'

import ShareCopy from '../Copy/ShareCopy'
import ShareLink from '../Link/ShareLink'
import { SOURCES } from '../constants'

import styles from './styles.module.css'
import ShareInstagram from '../Instagram/ShareInstagram'

const sources = ['whatsapp', 'twitter', 'email']

interface IShareContentProps {
  readonly propertyId: number
  readonly className?: string
}

export function ShareContent(props: IShareContentProps) {
  const { propertyId, className } = props
  return (
    <ul className={cn(className, styles.container)}>
      {sources.map(source => {
        const fullSource = SOURCES.find(s => s.name === source) ?? SOURCES[0]
        return (
          <li key={source}>
            <ShareLink propertyId={propertyId} source={{ ...fullSource }} />
          </li>
        )
      })}
      <ShareInstagram propertyId={propertyId} />
      <li>
        <ShareCopy propertyId={propertyId} />
      </li>
    </ul>
  )
}
